import { Backdrop, Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { Vortex } from 'react-loader-spinner';
import useLoadingActions from '@/hooks/useLoadingActions.tsx';

const LoadingBackdrop = () => {
  const { isLoading, message } = useLoadingActions();

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 999999,
      }}
      open={isLoading}
    >
      <Stack
        direction="column"
        spacing={1}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <Vortex
          visible={true}
          height="80"
          width="80"
          ariaLabel="vortex-loading"
          wrapperStyle={{}}
          wrapperClass="vortex-wrapper"
          colors={['red', 'green', 'blue', 'yellow', 'orange', 'purple']}
        />
        <Typography gutterBottom variant="h6" component="h2">
          {message}
        </Typography>
      </Stack>
    </Backdrop>
  );
};

export default LoadingBackdrop;
